/*eslint-disable no-console*/

import { io, Socket } from "socket.io-client";
// Define Socket.IO connection options
const socketOptions = {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 3,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 5000,
  autoConnect: true,
};

// Create Socket.IO client instance
const socket: Socket = io(
  process.env.REACT_APP_SOCKET_SERVERIO_URL ?? "",
  socketOptions
);

// Handle Socket.IO connection events
socket.on("connect", () => {
  console.log("Connected to Socket.IO server 😀");
});

socket.on("connect_error", (error) => {
  console.error("Socket.IO connection error:", error);
});

socket.on("disconnect", () => {
  console.log("Disconnected from Socket.IO server");
});

// Listen for 'chatMessage' and 'userData' events
socket.on("chatMessage", (message) => {
  console.log("Received chat message:", message);
});

socket.on("userData", (data) => {
  console.log("Received user data:", data);
});

// Subscribe to a Socket.IO event
export const subscribeToEvent = (
  eventName: string,
  callback: (...args: any[]) => void
): void => {
  socket.on(eventName, callback);
};

// Emit a Socket.IO event
export const emitEvent = (eventName: string, ...args: any[]): void => {
  socket.emit(eventName, ...args);
};

export default socket; // Export Socket.IO client instance
